import React from 'react';
import { FaSnowflake } from 'react-icons/fa';
import './SnowToggle.css';

const SnowToggle = ({ isSnowing, toggleSnow }) => {
  return (
    <button 
      className={`snow-toggle ${isSnowing ? 'active' : ''}`}
      onClick={toggleSnow}
      aria-label="Toggle snow effect"
      title={isSnowing ? 'Turn off snow' : 'Turn on snow'}
    >
      <FaSnowflake className="snowflake-icon" />
    </button>
  );
};

export default SnowToggle;
